import { Gift } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconGift12Line = createIcon(Gift, 12, "Line");
export const IconGift16Line = createIcon(Gift, 16, "Line");
export const IconGift20Line = createIcon(Gift, 20, "Line");
export const IconGift24Line = createIcon(Gift, 24, "Line");
export const IconGift32Line = createIcon(Gift, 32, "Line");
export const IconGift48Line = createIcon(Gift, 48, "Line");
export const IconGift64Line = createIcon(Gift, 64, "Line");
